import base64 from 'libwtgserver/base64';

angular.module('WTG.INTRACTABLE',['WTG.L']).factory('INTRACTABLE',
 function(L,$http,$rootScope) {
  var BASE64 = new base64();

  var url = window.location.origin;
  var token;

  var INTRACTABLE = {
   init: function init(h,p) {
    L.warn("don't use INTRACTABLE.init() as not sensible enough");
    return this.set_url(h+(p?':'+p:''));
   },
   set_url: function set_url(u) {
    url = u;
    return this;
   },
   set_token: function set_token(t) {
    token = t;
    return this;
   },
   has_token: function() { return !!token },
   request: function(action,params,opts,cb) {
    if(!url) return cb(new Error('intractable url is not set'));
    if(cb===undefined && opts instanceof Function)
     cb=opts, opts={};
    else if(!opts) opts={};
    var rq = {
     method: 'POST',
     url: url+'/api/'+action,
     data: params,
     cache: false,
     responseType: 'json'
    };
    if(params._C) {
     rq.withCredentials = true;
     delete params.C;
    }else if(opts.wc || opts.withCredentials) {
     rq.withCredentials = true;
    }
    // TODO: kill this code installed due to the server side fuckup:
    for(var p in params)
     if(angular.isNumber(params[p]))
      params[p] = ''+params[p];
    if(token && !params._T) params._T = token;
    L.trace({params:params,opts:opts},"intractable call "+action);
    $http(rq).then(function(r) {
     L.trace({a:action,r:r.data},"intractable response to "+action);
     cb(null,r.data);
    },function(r) {
     var e = new Error(r.statusText||'-failed-');
     e.details = {
      status:r.status, statusText:r.statusText,
      xhrStatus:r.xhrStatus };
     cb(e);
    });
   }
  };

  $rootScope.$on('wtg.interact.login',function on_interact_device_login(evt,args) {
   INTRACTABLE.set_token(BASE64.fromByteArray(args.token));
  });

  return INTRACTABLE;
 }
);
/* vim:set ts=8 sw=1 expandtab: */
